import { render, staticRenderFns } from "./ModattaCompaniesHero.vue?vue&type=template&id=60b150cb"
import script from "./ModattaCompaniesHero.vue?vue&type=script&lang=js"
export * from "./ModattaCompaniesHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports